import { urlBase } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

const baseUrl = `${urlBase}/portal-events/config-event`;

async function create(contract, jwt) {
  const config = {
    method: "post",
    url: `${baseUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: contract,
  };
  // O erro sobe para o componente: a tela precisa do status HTTP para explicar
  // a falha (ex.: 413, payload acima do limite do servidor).
  return axiosInstance(config).then((response) => response.data);
}

async function getByContractAndEvent(contractId, eventId) {
  const config = {
    method: "get",
    url: `${baseUrl}/${contractId}/contract/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function edit(data, contractId, eventId) {
  const config = {
    method: "put",
    url: `${baseUrl}/${contractId}/contract/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  // Mesmo motivo de create: o status HTTP precisa chegar ao componente.
  return axiosInstance(config).then((response) => response.data);
}

export { create, edit, getByContractAndEvent };
